import request from '@/utils/request';
// 领卡列表
export function getCardManagement(params) {
  return request({
    url: '/orders/card-management/index',
    method: 'get',
    params: params
  });
}
// 异常领卡列表
export function getDxceptiontList(params) {
  return request({
    url: '/orders/card-management/exception-index',
    method: 'get',
    params: params
  });
}
// 详情页
export function getDetail(params) {
  return request({
    url: '/orders/card-management/view',
    method: 'get',
    params: params
  });
}

// 领卡记录日志
export function getLog(params) {
  return request({
    url: '/orders/card-management/log',
    method: 'get',
    params: params
  });
}
// 作废回退
export function rollback(data) {
  return request({
    url: '/orders/card-management/rollback',
    method: 'post',
    data: data
  });
}
// 领取
export function receive(data) {
  return request({
    url: '/orders/card-management/receive',
    method: 'post',
    data: data
  });
}
// 领取编辑
export function receiveUpdate(data) {
  return request({
    url: '/orders/card-management/update',
    method: 'post',
    data: data
  });
}
// 领卡需求登记
export function demandCreate(data) {
  return request({
    url: '/orders/card-management/demand-create',
    method: 'post',
    data: data
  });
}
// 领卡需求登记-基本信息获取（TODO：接口地址待与后端确认）
export function getCardDemandDetail(params) {
  return request({
    url: '/orders/card-management/demand-info',
    method: 'get',
    params: params
  });
}
// 领卡需求登记-提交前校验领取人与登录人是否一致
export function checkReceiveUser(data) {
  return request({
    url: '/orders/card-management/check-receive-user',
    method: 'post',
    data: data
  });
}
// 领卡需求登记-根据客户ID获取领用人（销售）
export function getCustomerSale(params) {
  return request({
    url: '/orders/card-management/get-customer-sale',
    method: 'get',
    params: params
  });
}
// 领卡需求登记-添加物料选择列表
export function getDemandMaterialSelectList(params) {
  return request({
    url: '/orders/card-management/city-detail',
    method: 'get',
    params: params
  });
}
// 领卡登记-详情获取（领取/编辑回显用），参数 id 为数据id
export function getCardReceiveDetail(params) {
  return request({
    url: '/orders/card-management/info',
    method: 'get',
    params: params
  });
}
// 领卡登记-提交（列表领取/编辑）（TODO：接口地址待与后端确认）
export function receiveCardRegister(data) {
  return request({
    url: '/orders/card-management/receive-register',
    method: 'post',
    data: data
  });
}
// 领卡登记
export function cardManagementCreate(data) {
  return request({
    url: '/orders/card-management/create',
    method: 'post',
    data: data
  });
}

// 领卡取消
export function cardManagementDelete(data) {
  return request({
    url: '/orders/card-management/delete',
    method: 'post',
    data: data
  });
}
// 处理待售(提交)
export function exceptionCard(data) {
  return request({
    url: '/orders/card-management/exception-card',
    method: 'post',
    data: data
  });
}

// 处理待售(获取)
export function getExceptionCard(params) {
  return request({
    url: '/orders/card-management/exception-card',
    method: 'get',
    params: params
  });
}
// 查看客户脱敏信息
export function getCustomerName(params) {
  return request({
    url: '/count/order/get-customer-name',
    method: 'get',
    params: params
  });
}
// 领卡列表导出
export function getCardManagementExport(params) {
  return request({
    url: '/orders/card-management/export',
    method: 'get',
    params: params
  });
}
// 异常领卡列表导出
export function getCardManagementExcptionExport(params) {
  return request({
    url: '/orders/card-management/exception-export',
    method: 'get',
    params: params
  });
}
// 计算卡序列号
export function getLastCardNumber(params) {
  return request({
    url: '/orders/card-management/get-last-card-number',
    method: 'get',
    params: params
  });
}
// 其他物料领取/退还：
// 其他物料领用列表
export function getOtherMaterialReceiveList(params) {
  return request({
    url: '/material/order/other-receive-list',
    method: 'get',
    params: params
  });
}
// 其他物料领用详情-查看
export function getOtherMaterialReceiveDetail(params) {
  return request({
    url: '/material/order/other-receive-info',
    method: 'get',
    params: params
  });
}
// 其他物料领用详情-查看 退还物料明细（分页）
export function getOtherMaterialRefundList(params) {
  return request({
    url: '/material/order/other-refund-list',
    method: 'get',
    params: params
  });
}
// 【领卡列表】其他物料-领用（领用申请）
export function applyOtherMaterialReceive(data) {
  return request({
    url: '/material/order/other-receive-apply',
    method: 'post',
    data: data
  });
}
// 【领卡列表】其他物料-领用-选择-添加物料列表
export function getMaterialCity(data) {
  return request({
    url: '/material/order/city-detail',
    method: 'post',
    data: data
  });
}
// 其他物料领用导出
export function exportOtherMaterialReceive(params) {
  return request({
    url: '/material/order/other-receive-export',
    method: 'get',
    params: params
  });
}

// 【领卡列表】其他物料-领用（取消领用申请单）
export function cancelOtherMaterialReceive(data) {
  return request({
    url: '/material/order/other-receive-cancel',
    method: 'post',
    data: data
  });
}

// 【领卡列表】其他物料-领用（领取登记）
export function receiveOtherMaterial(data) {
  return request({
    url: '/material/order/other-receive-register',
    method: 'post',
    data: data
  });
}

// 【领卡列表】其他物料-领用（退还）
export function refundOtherMaterial(data) {
  return request({
    url: '/material/order/other-receive-refund',
    method: 'post',
    data: data
  });
}
//【领卡列表】其他物料-领用-选择-添加物料列表
export function getMaterialCityDetail(params) {
  return request({
    url: '/material/order/city-detail',
    method: 'get',
    params: params
  });
}
//【退还列表】其他物料-退还（列表）
export function getOtherMaterialReturnList(params) {
  return request({
    url: '/material/order/other-refund-list',
    method: 'get',
    params: params
  });
}
// 【退还列表】其他物料-退还（导出）
export function exportOtherMaterialReturn(params) {
  return request({
    url: '/material/order/other-refund-export',
    method: 'get',
    params: params
  });
}
// 【退还列表】其他物料-退还（查看）
export function getOtherMaterialReturnDetail(params) {
  return request({
    url: '/material/order/other-refund-info',
    method: 'get',
    params: params
  });
}
// 【退还列表】其他物料-退还（退还）提交
export function submitMaterialReturn(data) {
  return request({
    url: '/material/order/other-refund-refund',
    method: 'post',
    data: data
  });
}
// 【退还列表】其他物料-退还-选择-退还物料列表
export function getMaterialCityDetailReturn(params) {
  return request({
    url: '/material/order/receive-select-list',
    method: 'get',
    params: params
  });
}